export default [
  {
    path: '/notifications/stores/connect',
    name: 'stores-connect',
    component: () => import('@/views/notifications/connect/storesToConnect.vue'),
  },
  {
    path: '/notifications/stores/connect/qrcode/:session',
    name: 'stores-qrcode',
    component: () => import('@/views/notifications/connect/qrcode.vue'),
    params: true,
  },
  {
    path: '/dashboard/notifications/',
    name: 'dashboard-notifications',
    component: () => import('@/views/dashboard/notification/notification.vue'),
  },
  {
    path: '/notifications/status/:uuid',
    name: 'notifications-status',
    component: () => import('@/views/notifications/notifications2.vue'),
  },
  {
    path: '/notifications/status/payment/:uuid',
    name: 'notifications-status-payment',
    component: () => import('@/views/notifications/notificationsEdit/statusChoose.vue'),
  },
  {
    path: '/notifications/status/edit/:status/:uuid',
    name: 'notifications-status-edit',
    component: () => import('@/views/notifications/notificationsEdit/notificationEdit.vue'),
  },
  {
    path: '/notifications/config',
    name: 'notifications-config',
    component: () => import('@/views/notifications/ConfiguracoesNotificacoes.vue'),
  },
]
